import React, { useEffect, useCallback } from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';
import ProtocolTypeAheadField from 'components/Fields/typeAheads/ProtocolAndStatusTypeAhead';
import InstitutionTypeAhead from 'components/Fields/typeAheads/InstitutionTypeAhead';
import { SITE_CTEP_ID_NAME_MAP, VALIDATED_PROTOCOL_NUMBER_MAP } from './utils';

function LeftBox({
  isDisabled = false, title, button, data, setData, isInstitution, signatoryCtepId
}) {
  const onClear = useCallback(() => setData(new Set()), [setData]);

  useEffect(() => {
    if (isDisabled) {
      onClear();
    }
  }, [isDisabled, onClear]);
  const getTextAreaData = (val) => {
    if (val != null) {
      return Array.from(val).join(',');
    }
    return '';
  };
  const onTextareaChange = ({ target }) => {
    const { value } = target;
    const set = new Set();
    if (value != null && value.trim().length > 0) {
      value.split(',').forEach((val) => set.add(val.trim().toUpperCase()));
    }
    setData(set);
  };

  const onInstitutionChange = (selectedValue) => {
    if (selectedValue != null) {
      const { value, label } = selectedValue;
      if (value) {
        data.add(selectedValue.value);
      }
      SITE_CTEP_ID_NAME_MAP[value] = label;
      setData(new Set(data));
    }
  };

  const onChangeProtocol = (selectedValue) => {
    if (selectedValue != null) {
      const { value } = selectedValue;
      if (value) {
        data.add(selectedValue.value);
      }
      VALIDATED_PROTOCOL_NUMBER_MAP[value] = true;
      setData(new Set(data));
    }
  };

  const enteredData = getTextAreaData(data);

  return (
    <div className="mb-4">
      <div className="row">
        <div className="col-6">
          <div className="mr-1 font-semibold color-dark-blue">{title}</div>
          {isInstitution ? (
            <InstitutionTypeAhead
              signatoryCtepId={signatoryCtepId}
              isDisabled={isDisabled}
              onChange={onInstitutionChange}
            />
          ) : (
            <ProtocolTypeAheadField isDisabled={isDisabled} onChange={onChangeProtocol} />
          )}
        </div>
        <div className="col-6 align-right">
          {enteredData !== '' ? (
            <button
              data-id={`${ATC.PACKETID}${button.split(' ').join('_').toUpperCase()}${ATC.BUTTON}`}
              type="button"
              onClick={onClear}
              className="btn turquoise mt-4"
            >
              {button}
            </button>
          ) : (
            <button
              data-id={`${ATC.PACKETID}${button.split(' ').join('_').toUpperCase()}${ATC.BUTTON}`}
              type="button"
              onClick={onClear}
              className="btn turquoise mt-4"
              disabled
            >
              {button}
            </button>
          )}
        </div>
      </div>
      <div className="row pt-2">
        <textarea
          disabled={isDisabled}
          data-id={`${ATC.PACKETID}COMMENTS${ATC.TEXTAREA}`}
          className="form-control"
          rows={4}
          onChange={onTextareaChange}
          value={enteredData}
        />
      </div>
    </div>
  );
}

export default LeftBox;
